import {
  CLSReportCallback,
  FCPReportCallback,
  FIDReportCallback,
  INPReportCallback,
  LCPReportCallback,
  onCLS,
  onFCP,
  onFID,
  onINP,
  onLCP,
  onTTFB,
  TTFBReportCallback,
} from 'web-vitals';
import { dataLayer } from '../utils/googleTagManagerUtil';

/**
 * useWebVitals
 */
export const useWebVitals = () => {
  const setVariableTTFB: TTFBReportCallback = ({ value }) => {
    dataLayer({
      event: 'webvitals_TimetoFirstByte',
      TimetoFirstByte: Math.floor(value * 100),
    });
  };

  const setVariableFCP: FCPReportCallback = ({ value }) => {
    dataLayer({
      event: 'webvitals_FirstContentfulPaint',
      FirstContentfulPaint: Math.floor(value * 100),
    });
  };

  const setVariableLCP: LCPReportCallback = ({ value }) => {
    dataLayer({
      event: 'webvitals_LargestContentfulPaint',
      LargestContentfulPaint: Math.floor(value * 100),
    });
  };

  const setVariableFID: FIDReportCallback = ({ value }) => {
    dataLayer({
      event: 'webvitals_FirstInputDelay',
      FirstInputDelay: Math.floor(value * 100),
    });
  };

  const setVariableCLS: CLSReportCallback = ({ value }) => {
    setTimeout(() => {
      dataLayer({
        event: 'webvitals_CumulativeLayoutShift',
        CumulativeLayoutShift: Math.floor(value * 100),
      });
    }, 5000);
  };

  const setVariableINP: INPReportCallback = ({ value }) => {
    window.dataLayer = window.dataLayer || [];
    dataLayer({
      event: 'webvitals_InteractionToNextPaint',
      InteractionToNextPaint: Math.floor(value * 100),
    });
  };

  const reportWebVitals = () => {
    onTTFB(setVariableTTFB);
    onFCP(setVariableFCP);
    onLCP(setVariableLCP);
    onFID(setVariableFID);
    onCLS(setVariableCLS, {
      reportAllChanges: true,
    });
    onINP(setVariableINP, {
      reportAllChanges: true,
    });
  };
  return reportWebVitals;
};
